var _a;
export var GrupoCampoAnalise;
(function (GrupoCampoAnalise) {
    GrupoCampoAnalise["DADOS_GERAIS"] = "DADOS_GERAIS";
    GrupoCampoAnalise["CONTATO"] = "CONTATO";
    GrupoCampoAnalise["ENDERECO"] = "ENDERECO";
})(GrupoCampoAnalise || (GrupoCampoAnalise = {}));
export var EntidadeAnalise;
(function (EntidadeAnalise) {
    EntidadeAnalise["EMPRESA"] = "EMPRESA";
    EntidadeAnalise["FUNCIONARIO"] = "FUNCIONARIO";
    EntidadeAnalise["SOCIO"] = "SOCIO";
    EntidadeAnalise["OPERADOR"] = "OPERADOR";
    EntidadeAnalise["VEICULO"] = "VEICULO";
})(EntidadeAnalise || (EntidadeAnalise = {}));
export var StatusItemAnalise;
(function (StatusItemAnalise) {
    StatusItemAnalise["NAO_ANALISADO"] = "NAO_ANALISADO";
    StatusItemAnalise["APROVADO"] = "APROVADO";
    StatusItemAnalise["REPROVADO"] = "REPROVADO";
})(StatusItemAnalise || (StatusItemAnalise = {}));
export var StatusGeralAnalise;
(function (StatusGeralAnalise) {
    StatusGeralAnalise["AGUARDANDO_ANALISE"] = "AGUARDANDO_ANALISE";
    StatusGeralAnalise["EM_ANALISE"] = "EM_ANALISE";
    StatusGeralAnalise["PENDENTE"] = "PENDENTE";
    StatusGeralAnalise["APROVADO"] = "APROVADO";
    StatusGeralAnalise["REPROVADO"] = "REPROVADO";
})(StatusGeralAnalise || (StatusGeralAnalise = {}));
export var StatusGeralAnaliseDescription = (_a = {},
    _a[StatusGeralAnalise.AGUARDANDO_ANALISE] = 'Aguardando Análise',
    _a[StatusGeralAnalise.EM_ANALISE] = 'Em Análise',
    _a[StatusGeralAnalise.PENDENTE] = 'Pendente - Aguardando Complementação',
    _a[StatusGeralAnalise.APROVADO] = 'Aprovado',
    _a[StatusGeralAnalise.REPROVADO] = 'Reprovado',
    _a);
